export const filterPrice = {
  queryName: 'price',
  name: 'Price',
  options: ['Free', 'Premium'],
};

export const filterStyleDescription =
  'font style brings unique characteristics and visual appeal to your designs. All fonts can be styled with any colors in the editor.';
export const filterStyleMetaDataTitle = '[style] Fonts - Explore Various Font Styles';
export const filterStyleAndCategoryMetaDataTitle = 'Font Styles';
export const filterStyleMetaDataDescription =
  'Explore [style] fonts for your projects. Find versatile styles that bring creativity and impact to your designs. Start browsing now';
export const keyForTheMetaDescription = 'Explore a list of';

export const filterStyle = {
  queryName: 'style',
  name: 'Style',
  options: [
    'Bold',
    'Cursive',
    'Italic',
    'Fancy',
    'Cool',
    'Small',
    'Glitch',
    'Outline',
    'Bold Italic',
    'Condensed',
    'Shadow',
    'Thin',
    'Light',
    'Regular',
  ],
};
